// ========== INFO-SECTION: Lazy-load Google Maps via IntersectionObserver ==========
// Extracted from sections/RD-info-section.liquid (lines 155-201)
(function() {
  var placeholder = document.getElementById('map-placeholder');
  if (!placeholder) return;

  var mapSrc = placeholder.getAttribute('data-map-src');
  if (!mapSrc) return;

  var loaded = false;

  function loadMap() {
    if (loaded) return;
    loaded = true;

    var iframe = document.createElement('iframe');
    iframe.src = mapSrc;
    iframe.width = "100%";
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('-infotitle', 'Mapa PANACA Punta Cana');
    iframe.className = 'map-preview';

    // Inserta el iframe EN LA MISMA POSICIÓN que el placeholder (antes del botón)
    placeholder.parentNode.insertBefore(iframe, placeholder);
    placeholder.remove();
  }

  // IntersectionObserver: carga cuando el mapa entra en viewport
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          loadMap();
          observer.unobserve(placeholder);
        }
      });
    }, { rootMargin: '200px' });
    observer.observe(placeholder);
  } else {
    // Fallback: carga inmediatamente si no soporta IntersectionObserver
    loadMap();
  }
})();
